<div class="topbar">
  <div>
    <h1>Indstillinger for Tilvalg</h1>
  </div>
  <div class="topbar__actions">
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret installatør">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret tilvalg</span>
      </button>
    }
    <div class="search-wrap">
      <!-- <app-search [searchString]="searchQuery" label="Søg installatør på CVR el. navn"></app-search> -->
    </div>
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    @for (group of tilvalgGroups; track group) {
      <div class="margin--bottom-l">
        <h2 class="margin--bottom-xs">{{ group.shortname }}</h2>
        @if (tilvalgGroups?.length == 0) {
          <div class="align-center">
            <p class="orange">
              <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
              <br />
              Ingen tilvalg defineret
            </p>
          </div>
        }
        @if (tilvalgGroups?.length > 0) {
          <table mat-table [dataSource]="getTilvalg(group)" class="mat-elevation-z0">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Navn</th>
              <td mat-cell *matCellDef="let row">{{ row.name }}</td>
            </ng-container>
            <ng-container matColumnDef="tilvalgType">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let row">
                {{ row.tilvalgType }}
              </td>
            </ng-container>
            <ng-container matColumnDef="okKundeVarenr">
              <th mat-header-cell *matHeaderCellDef>Varenummer</th>
              <td mat-cell *matCellDef="let row">
                {{ row.okKundeVarenr }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <div class="hidden-cell">
                  @if (row.isActive) {
                    <button
                      (click)="edit(row)"
                      class="btn-icon blue"
                      aria-label="Rediger tilvalg"
                      matTooltip="Rediger tilvalg"
                      >
                      <mat-icon svgIcon="edit"></mat-icon>
                    </button>
                  }
                  <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
                    <mat-icon>timeline</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        }
      </div>
    }
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
